import { Value } from "../../../Pages/DataManagement/DataExplorer/DataExplorerUI/ExplorerInputs/FieldOperatorList";
import { likeOperator } from "../../../utils/constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function PartialMatch(props) {
  const { setLikeEnabled, select, searchValue, filter } = props;

  const selectFilterWithLikeOperator = () => {
    setLikeEnabled(true);
    select({
      ...filter,
      value: searchValue,
      operator: likeOperator,
      label: searchValue,
    });
  };

  return (
    <div title="Partial Match">
      <Value
        onClick={selectFilterWithLikeOperator}
        style={{
          height: 29,
          marginLeft: 5,
          marginTop: 1,
        }}
        isDisabled={!searchValue}
      >
        <FontAwesomeIcon icon={["fas", "search"]} />
      </Value>
    </div>
  );
}
